import React from 'react';
import { SectionHeader } from '../../primitives/SectionHeader';
import { FAQCard } from '../../cards/FAQCard';
import { space } from '../../tokens';
import { DraggableElement } from '../../../DraggableElement';
import { InlineEditableText } from '../../../InlineEditableText';

const FAQS = [
  { q: 'Wie lange dauert die Installation?', a: 'Je nach Anlagengröße 1–3 Wochen. Wir koordinieren alle Gewerke und stellen sicher, dass Ihr Betrieb so wenig wie möglich beeinträchtigt wird.' },
  { q: 'Was passiert nach Ablauf der Laufzeit?', a: 'Sie können die PV-Anlage kostenlos übernehmen, den Vertrag verlängern oder die Demontage veranlassen – ganz nach Ihren Wünschen.' },
  { q: 'Wer haftet bei Schäden oder Ausfall?', a: 'EN:POWER trägt die vollständige Betriebsverantwortung. Die Anlage ist vollständig versichert. Sie tragen keinerlei Haftungsrisiko.' },
  { q: 'Was beinhaltet die Dachsanierung?', a: 'Abdichtung, Substanzsicherung und alle Montagevorarbeiten – auf Kosten von EN:POWER, komplett ohne Eigenaufwand.' },
  { q: 'Können die Pachteinnahmen steigen?', a: 'Ja. Je nach Vereinbarung kann eine Indexierung an die Inflationsrate oder den Strompreis vereinbart werden.' },
  { q: 'Ist das Angebot verbindlich?', a: 'Nein. Das Indikationsangebot ist unverbindlich. Rechtsverbindlich wird es erst nach beidseitiger Unterzeichnung des Dachnutzungsvertrags.' },
];

/**
 * FAQSection – "Haben Sie noch Fragen?" auf Page 4.
 * 6 FAQCards aus exakt derselben Komponente, gleichmäßig im Grid.
 */
export const FAQSection = ({ content = {}, onTextChange, editMode = false, layoutEditLevel = 'section', dragProps = {} }) => {
  const faqText = {
    header: {
      eyebrow: content?.header?.eyebrow || 'Häufige Fragen',
      headline: content?.header?.headline || 'HABEN SIE NOCH FRAGEN?',
    },
  };
  const faqs = Array.isArray(content?.items) && content.items.length > 0 ? content.items : FAQS;

  return (
  <>
    {layoutEditLevel === 'detail' ? (
      <DraggableElement id="S4-FAQ-Header" {...dragProps} dragAxis="y">
        <div style={{ padding: `${space.lg}px ${space.xxl}px ${space.sm}px`, background: 'white', flexShrink: 0 }}>
          <SectionHeader
            eyebrow={<InlineEditableText as="span" value={faqText.header.eyebrow} editable={editMode} onChange={(value) => onTextChange?.('page4.faq.header.eyebrow', value)} />}
            headline={<InlineEditableText as="span" value={faqText.header.headline} editable={editMode} onChange={(value) => onTextChange?.('page4.faq.header.headline', value)} />}
          />
        </div>
      </DraggableElement>
    ) : (
      <div style={{ padding: `${space.lg}px ${space.xxl}px ${space.sm}px`, background: 'white', flexShrink: 0 }}>
        <SectionHeader
          eyebrow={<InlineEditableText as="span" value={faqText.header.eyebrow} editable={editMode} onChange={(value) => onTextChange?.('page4.faq.header.eyebrow', value)} />}
          headline={<InlineEditableText as="span" value={faqText.header.headline} editable={editMode} onChange={(value) => onTextChange?.('page4.faq.header.headline', value)} />}
        />
      </div>
    )}

    <div
      style={{
        padding: `${space.lg}px ${space.xxl}px ${space.lg + space.xs}px`,
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridTemplateRows: 'auto auto', gap: `${space.md}px`, width: '100%' }}>
        {faqs.map((f, i) => (
          layoutEditLevel === 'detail' ? (
            <DraggableElement key={i} id={`S4-FAQ-${i + 1}`} {...dragProps} dragAxis="y">
              <FAQCard question={f.q} answer={f.a} />
            </DraggableElement>
          ) : (
            <FAQCard key={i} question={f.q} answer={f.a} />
          )
        ))}
      </div>
    </div>
  </>
  );
};
